import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    // ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
} from './GlobalConstants';
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/michael-hill%2Fshow-2022%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "left";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";


const AnnotationsDB = [

    /* Annotations */
    {
        paintingId:"WXXP02",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP02.jpg/info.json`,
        headerText:"<h5>Mirror Image 1</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original (mounted) £110; signed limited edition 4 colour print £80; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
        emailSubjectText: `Enquiry`,
        EnquireEmail: 'michaelhillart@btinternet.com',
    },
    {
        paintingId:"WXXP03",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP03.jpg/info.json`,
        headerText:"<h5>Skelter Helter</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original (mounted) £110; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
        emailSubjectText: `Enquiry`,
        EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP04",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP04.jpg/info.json`,
        headerText:"<h5>Into the Void</h5>",
        bodyText:`H 70 x 50 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>£110`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP05",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP05.jpg/info.json`,
        headerText:"<h5>Trotting the Line</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original £120; signed limited edition 4 colour print £80; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP06",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP06.jpg/info.json`,
        headerText:"<h5>Cadmium and Rebrum</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original £90; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP07",
        videoId:"",
        videoURL:"",
        // iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP07.jpg/info.json`,
        iiifMultiSource:[`${CANTALOUPE_IMAGE_SERVER}WXXP07.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}WXXP07A01.jpg/info.json`],
        headerText:"<h5>Nuclear Winter</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original £90; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP08",
        videoId:"",
        videoURL:"",
        // iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP08.jpg/info.json`,
        iiifMultiSource:[`${CANTALOUPE_IMAGE_SERVER}WXXP08.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}WXXP08A01.jpg/info.json`],
        headerText:"<h5>Screen Capture</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, ink on paper<br>2022<br>Original SOLD; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP09",
        videoId:"",
        videoURL:"",
        // iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP09.jpg/info.json`,
        iiifMultiSource:[`${CANTALOUPE_IMAGE_SERVER}WXXP09.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}WXXP09A01.jpg/info.json`],
        headerText:"<h5>Mirror Image 2</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original £90; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP10",
        videoId:"",
        videoURL:"",
        // iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP10.jpg/info.json`,
         iiifMultiSource:[`${CANTALOUPE_IMAGE_SERVER}WXXP10.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}WXXP10A01.jpg/info.json`],
        headerText:"<h5>Veg and 2 Meat</h5>",
        bodyText:`H 60 x W 40 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original £110; signed digital copy print £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP11",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP11.jpg/info.json`,
        headerText:"<h5>Fake News</h5>",
        bodyText:`H 60 x W 40 cm<br>Pen, charcoal, lettrasett on paper<br>2019<br>£90`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP12",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP12.jpg/info.json`,
        headerText:"<h5>Distant Seeing</h5>",
        bodyText:`H 50 x W 40 cm<br>Acrylic and emulsion paint, crayon, pen on canvas<br>2020<br>£90`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP13",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP13.jpg/info.json`,
        headerText:"<h5>Skulduggery</h5>",
        bodyText:`H 80 x W 50 cm<br>Acrylic, emulsion paint, gesso on canvas, resin surface<br>2022<br>SOLD`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP14",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP14.jpg/info.json`,
        headerText:"<h5>Fall^Out (print)</h5>",
        bodyText:`H 80 x W 70 cm<br>Acrylic, emulsion, spray paint on   canvas (original)<br>2021<br>£110`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP15",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP15.jpg/info.json`,
        headerText:"<h5>The Squeeze is On</h5>",
        bodyText:`H 80  x W 60<br>Oil paint on box canvas<br>2020<br>£100   `,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP16",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP16.jpg/info.json`,
        headerText:"<h5>Mortal Remains</h5>",
        bodyText:`H 90 x W 60 cm<br>Acrylic, emulsion paint on board<br>2020<br>SOLD`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP17",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP17.jpg/info.json`,
        headerText:"<h5>PD2</h5>",
        bodyText:`H 80 x W 60 cm<br>Acrylic and emulsion paint, crayon, pen on canvas<br>2019<br>£90`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP18",
        videoId:"",
        videoURL:"",
        // iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP18.jpg/info.json`,
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP18C02.jpg/info.json`,
        headerText:"<h5>Art Cannot Be Killed</h5>",
        bodyText:`H 40 x W 60 cm<br>Acrylic and emulsion paint, pen on paper<br>2022<br>Original SOLD; signed limited edition 4 colour print £100; signed digital copy £70`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP19",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP19.jpg/info.json`,
        headerText:"<h5>Grilled (print)</h5>",
        bodyText:`H 25 x W 40 cm<br>Emulsion paint, pen on canvas  (original)<br>2019<br>£50`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP20",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP20.jpg/info.json`,
        headerText:"<h5>Grilled (print)</h5>",
        bodyText:`H 25 x W 40 cm<br>Emulsion paint, pen on canvas  (original)<br>2019<br>£50`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP21",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP21.jpg/info.json`,
        headerText:"<h5>Fallen</h5>",
        bodyText:`H 60 x W 90 cm<br>Aluminium metal cut outs on board<br>2019<br>SOLD`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP22",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP22.jpg/info.json`,
        headerText:"<h5>Oran (print)</h5>",
        bodyText:`H 120 x W 80 cm<br>Acrylic, emulsion, spray paint on paper (original)<br>2019<br>£250`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
     {
        paintingId:"WXXP23",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP23.jpg/info.json`,
        headerText:"<h5>9. 1225.1292.12</h5>",
        bodyText:`H 120 x W 100 cm<br>Acrylic, emulsion paint, chalk on box canvas<br>2022<br>£250`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
         emailSubjectText: `Enquiry`,
         EnquireEmail: 'michaelhillart@btinternet.com',
    },
    {
        paintingId:"WXXP26",
        videoId:"",
        videoURL:"",
        iiifSource:`${CANTALOUPE_IMAGE_SERVER}WXXP26.jpg/info.json`,
        headerText:"<h5>Under Surveillance</h5>",
        bodyText:`H 42 x W 32 cm<br>Acrylic, oil, inkcrayon on canvas (original)<br>2020<br>Original SOLD, signed digital copy print with mount £60`,
        displayMesh:"Y",
        useMeshButton:"N",
        ContactURL: 'http://www.michaelhillart.co.uk/',
        emailSubjectText: `Enquiry`,
        EnquireEmail: 'michaelhillart@btinternet.com',
    },
    /* Annotations */
];

export {AnnotationsDB};
